/**
 * Remonte au serveur les erreurs JavaScript des postes (écran blanc, bouton
 * qui ne répond pas…), pour qu'elles apparaissent dans Plateforme › Supervision
 * et déclenchent une alerte. Rien n'est envoyé hors connexion ni sans compte
 * connecté, et une même erreur n'est envoyée qu'une fois par minute.
 */
import { API_BASE } from '@/api'

const DEJA_ENVOYEES = new Map()
const DELAI_MS = 60 * 1000

function texte(v, max) {
  return String(v == null ? '' : v).slice(0, max)
}

export function signalerErreur(erreur, { composant = null, type = null } = {}) {
  try {
    const token = localStorage.getItem('token')
    if (!token || !navigator.onLine) return

    const message = texte(erreur?.message || erreur, 1000)
    if (!message || /ResizeObserver loop|Loading chunk|ChunkLoadError|NavigationDuplicated|Avoided redundant navigation|Network Error|timeout of \d+ms/i.test(message)) return

    const cle = message + '|' + (composant || '')
    const maintenant = Date.now()
    if (DEJA_ENVOYEES.has(cle) && maintenant - DEJA_ENVOYEES.get(cle) < DELAI_MS) return
    DEJA_ENVOYEES.set(cle, maintenant)

    const corps = JSON.stringify({
      message,
      type: type || erreur?.name || 'Erreur JavaScript',
      pile: texte(erreur?.stack, 6000),
      composant: composant ? texte(composant, 150) : null,
      page: window.location.pathname,
      navigateur: texte(navigator.userAgent, 300),
    })

    fetch(`${API_BASE}/api/v1/surveillance/erreur-navigateur`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: corps,
      keepalive: true,
    }).catch(() => {})
  } catch (e) {
    // La remontée d'erreur ne doit jamais provoquer d'erreur
  }
}

/** Branche la remontée sur l'application Vue et sur la fenêtre. */
export function installerSurveillance(app) {
  const precedent = app.config.errorHandler
  app.config.errorHandler = (err, instance, info) => {
    const nom = instance?.$options?.name || instance?.$options?.__name || instance?.$options?.__file || ''
    signalerErreur(err, { composant: [nom, info].filter(Boolean).join(' · ') })
    if (precedent) precedent(err, instance, info)
    // eslint-disable-next-line no-console
    console.error(err)
  }
  window.addEventListener('error', (ev) => {
    if (ev?.error) signalerErreur(ev.error)
  })
  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev?.reason
    // Erreurs d'API (réponse du serveur) : déjà connues du serveur, ou normales (403, 409…)
    if (r && (r.isAxiosError || r.response)) return
    if (r) signalerErreur(r instanceof Error ? r : new Error(String(r)), { type: 'Promesse rejetée' })
  })
}

/**
 * Service worker : l'application s'ouvre même sans internet (voir public/sw.js).
 * Seulement en production et sur une adresse sécurisée (https ou localhost).
 */
export function installerHorsLigne() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return
  if (!window.isSecureContext) return
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      // Nouvelle version de l'interface : mise à jour de la copie du poste
      if (navigator.onLine && reg.active) reg.active.postMessage('mettre-a-jour')
    }).catch(() => {})
  })
}
